"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextareaVariants = exports.TextareaVariantTypes = exports.TextareaStates = exports.TextareaSizes = void 0;
var TextareaVariants = {
  Primary: 'primary'
};
exports.TextareaVariants = TextareaVariants;
var TextareaVariantTypes = {
  Default: 'default',
  Generic: 'generic'
};
exports.TextareaVariantTypes = TextareaVariantTypes;
var TextareaStates = {
  Default: 'default',
  Error: 'error'
};
exports.TextareaStates = TextareaStates;
var TextareaSizes = {
  Tiny: 'tiny',
  Small: 'small',
  Normal: 'normal',
  Big: 'big',
  Huge: 'huge'
};
exports.TextareaSizes = TextareaSizes;